export default function getTaxedPrice(price) {
  if (!price) return null;
  return Math.ceil(((100 * price) / 97.8 + 0.5).toFixed(2));
}
